export default {"src":"/_next/static/media/Global.8e7b9bfe.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};